import React from 'react';
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Col,
  Grid,
  StatsCard,
  StatsCardBody,
  StatsCardHeader,
  StatsCardItem,
  Title,
} from '@common/components';
import cardClasses from './CardSampleView.module.scss';
import { usersMock } from '../../mocks/index';

export default function CardSampleView() {
  return (
    <div className={cardClasses.grid}>
      <Title type="h1">Cards demo</Title>
      <Card>Basic card</Card>
      <Card>
        <CardHeader>
          <Title type="h3">Header card</Title>
        </CardHeader>
        <CardContent>Content card</CardContent>
        <CardFooter>Footer card</CardFooter>
      </Card>

      <Card className={cardClasses.custom1}>
        <CardHeader className={cardClasses.header1}>
          <Title type="h3">Custom card</Title>
        </CardHeader>
        <CardContent>
          <img
            className={cardClasses.picture}
            alt="demo"
            src="https://picsum.photos/1800/400"
          />
          <Title type="p">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eu
            nibh arcu. Duis aliquam accumsan feugiat. Mauris ornare, tellus eu
            aliquet tempus, justo enim vehicula arcu, fringilla eleifend est
            diam vestibulum orci. Quisque venenatis libero tortor, id facilisis
            lacus tempor congue. Aliquam lobortis auctor risus, non tincidunt
            arcu tincidunt nec. Sed imperdiet, metus at eleifend lacinia, sem
            ligula consequat erat, at scelerisque odio mauris vel metus. Nulla
            ullamcorper, nulla sed volutpat rutrum, urna lacus molestie mauris,
            finibus varius lacus nunc in mi. Ut tortor quam, interdum ac quam
            ut, maximus placerat est. Praesent eu auctor urna. In quis aliquam
            ante. Curabitur rutrum elit eget urna efficitur, pulvinar placerat
            risus egestas.
          </Title>
        </CardContent>
        <CardFooter className={cardClasses.footer1}>
          <Grid align="middle" justify="center">
            <Col flex justify="center" xs={6}>
              <Button variant="flat">Primary action</Button>
            </Col>
            <Col flex justify="center" xs={6}>
              <Button variant="flat" color="error">
                Delete action
              </Button>
            </Col>
          </Grid>
        </CardFooter>
      </Card>
      <Title type="h2">Grid of cards</Title>
      <Grid>
        {usersMock.map((user) => (
          <Col key={user.guid} xss={12} xs={6} sm={4}>
            <Card>
              <CardHeader>
                <Title type="h2">{user.name}</Title>
              </CardHeader>
              <CardContent>
                <img
                  className={cardClasses.picture}
                  alt="demo"
                  src="https://picsum.photos/300/100"
                />
                <Title type="p">Age: {user.age}</Title>
                <Title type="p">GUID: {user.guid}</Title>
              </CardContent>
            </Card>
          </Col>
        ))}
      </Grid>
      <Title type="h2">Grid of StatsCards</Title>
      <Grid>
        <Col xss={12} xs={6} sm={3}>
          <StatsCard>
            <StatsCardHeader>
              <Title type="h2">Centers</Title>
              <StatsCardBody>
                <StatsCardItem>
                  <Title type="p">centros</Title>
                  <Title type="p">15</Title>
                </StatsCardItem>
                <StatsCardItem>
                  <Title type="p">clases</Title>
                  <Title type="p">98</Title>
                </StatsCardItem>
              </StatsCardBody>
            </StatsCardHeader>
          </StatsCard>
        </Col>
        <Col xss={12} xs={6} sm={3}>
          <StatsCard>
            <StatsCardHeader>
              <Title type="h2">User Times</Title>
              <StatsCardBody>
                <StatsCardItem>
                  <Title type="p">Teachers</Title>
                  <Title type="p">1 d 15 h 25 min</Title>
                </StatsCardItem>
                <StatsCardItem>
                  <Title type="p">Students</Title>
                  <Title type="p">2 d 49 h 15 min </Title>
                </StatsCardItem>
              </StatsCardBody>
            </StatsCardHeader>
          </StatsCard>
        </Col>
      </Grid>
    </div>
  );
}
